import { render, staticRenderFns } from "./PaymentDisapproved.vue?vue&type=template&id=a88c24f4&"
import script from "./PaymentDisapproved.vue?vue&type=script&lang=js&"
export * from "./PaymentDisapproved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports